import React                  from 'react';
import {connect}              from 'react-redux';
import { Link }               from 'react-router-dom';
import { SetError }           from '../../../actions/authenticActions';
import { GetListaMenuTopo,
         GetListaSubMenuTopo} from '../../../actions/scopoAction';
import Disciplina             from "../disciplina/professor_disciplina";

class Missao_disciplina_professor extends React.Component {

    componentWillMount(){

        this.props.GetListaMenuTopo([
            {action:true,nome:"Home",link:this.props.menu.home},
            {action:false,nome:this.props.menu.desafios.nomeModulo},
            {action:false,nome:'Unidade Curricular'}
           ]);
        this.props.GetListaSubMenuTopo([]);
    }

    render() {
    
        return (<div className="container-bg">
                    <div className="titulo-pages topo_conteudo">
                        <div className="pull-right">
                            <Link to={`${this.props.menu.desafios.novo}`} className="btn btn-primary pull-right">Cadastro</Link>
                        </div>
                    </div>
                    <Disciplina checkList={true} menuParametro={this.props.menu.desafios.desafio_turma}/>
                </div>);
    }
}

function mapStateToProps(state){

    return {
            session : state.auth.session,  
            menu : state.configReducer.menu
           }
}

export default connect(mapStateToProps,{ GetListaMenuTopo,
                                         GetListaSubMenuTopo,
                                         SetError
                                        })(Missao_disciplina_professor); 



// WEBPACK FOOTER //
// ./src/components/professor/desafios/desafios_professor_disciplina.js